import axios from "axios";

export const getCidades = (params : string) => api.get(`getCidade?${params}`);
export const getEstados = () => api.get(`getEstado`);
export const getVeiculos = (params: string) => api.get(`getveiculos?${params}`);
export const getLayoutModelo = (params : string) => api.get(`getLayoutModelo?${params}`);
export const postGarantia = (body: any) => api.post(`salvar`, body);
export const putGarantia = (body: any) => api.post(`alterar`, body);
export const getCertificado = (id: string) => api.get(`getCertificado?guidReferencia=${id}`);
export const getPrivacidade = (params: string) => api.get(`getPrivacidade?${params}`);
export const getDownloadPdf = (params: string) => api.get(`DownloadPdf?guidReferencia=${params}`);
export const getEnviarEmail = (params: string,idioma:string) => api.get(`getEnviarEmail?guidReferencia=${params}&idioma=${idioma}`);
export const getNumeroSerie = (params: string) => api.get(`getNumeroSerie?${params}`);
export const getAllResources = () => apiStatic.get(`idiomas/certificado-garantia.json`);

const api = axios.create({
    baseURL: process.env.REACT_APP_URL_API,//appSettings.apiUrl""
    
    //baseURL: "https://www.vm2.com.br/cms/heliar/util/"
});

const apiStatic = axios.create({
    baseURL: process.env.REACT_APP_DOWNLOAD,//appSettings.apiUrl""
    
    //baseURL: "https://www.vm2.com.br/cms/heliar/util/"
});


function log(message:string) {   
    console.debug(message);
}

api.interceptors.request.use(async config => {
    log(`Request tipo [${config.method}] na rota [${config.url}]`);
    config.url = `${config.url}`
    

    if(config.method == "post"){
        //config.withCredentials = true;
        //config.headers.set("Cookie","ASP.NET_SessionId=g2rfzavxol20gz4pcbywatb5");
        //config.headers["Content-Type"] = "application/json";
        //config.headers.set("Access-Control-Allow-Origin","http://localhost:3000");
    }

    return config;
});


api.interceptors.response.use(
    res => {
        const {config: {method, url}, status, data, data: {error, success}} = res;

        // log(`SUCESSO: [${method.toUpperCase()}] na rota [${url}] status [${status}]`);

        return data;
    },
    err => {
        console.log(err);
        if (err?.response?.status === 401) {
            //removeItem(AUTHED_USER);

            return setTimeout(() => {
                window.location.reload()
            }, 1000);
        }
        throw err;
    });

export default api;
